import React from 'react';
import { LineChart, Line, ResponsiveContainer } from 'recharts';
import { FiArrowUp, FiArrowDown } from 'react-icons/fi';
import { InfoTooltip } from '@/components/InfoTooltip';
import styles from '../DashboardOverviewNew.module.scss';

const TEAM_PERFORMANCE_TOOLTIP = {
  description:
    "A side-by-side view of every employee's productivity score, active/idle/focus time, attendance, and recent trend, so you can compare performance across the team at a glance.",
  calculation: {
    label: 'How it works',
    formula:
      'Each column uses the same definitions as the cards above, computed per employee.',
  },
};

const Sparkline = ({ data, color }) => {
  const chartData = data.map((v, i) => ({ i, v }));
  return (
    <ResponsiveContainer width={80} height={30}>
      <LineChart data={chartData}>
        <Line
          type="monotone"
          dataKey="v"
          stroke={color}
          strokeWidth={1.5}
          dot={false}
          isAnimationActive={false}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export const TeamPerformance = ({ data }) => (
  <div className={styles.teamCard}>
    <div className={styles.cardHeader}>
      <div className={styles.cardTitleGroup}>
        <span className={styles.cardTitle}>Department Performance</span>
        <InfoTooltip
          title="Department Performance"
          {...TEAM_PERFORMANCE_TOOLTIP}
        />
      </div>
    </div>

    <div className={styles.teamTableWrapper}>
      <table className={styles.teamTable}>
        <thead className={styles.teamTableHead}>
          <tr>
            <th>Employee</th>
            <th>Productivity Score</th>
            <th>Active Time</th>
            <th>Idle Time</th>
            <th>Focus Time</th>
            <th>Attendance</th>
            <th>Trend</th>
          </tr>
        </thead>
        <tbody className={styles.teamTableBody}>
          {data.map((emp) => (
            <tr key={emp.id}>
              <td>
                <div className={styles.employeeCell}>
                  <div
                    className={styles.employeeAvatar}
                    style={{
                      backgroundColor: emp.avatarBg,
                      color: emp.avatarColor,
                    }}
                  >
                    {emp.avatar}
                  </div>
                  <div className={styles.employeeInfo}>
                    <span className={styles.employeeName}>{emp.name}</span>
                    <span className={styles.employeeRole}>{emp.role}</span>
                  </div>
                </div>
              </td>

              <td>
                <div className={styles.scoreCell}>
                  <span className={styles.scoreValue}>
                    {emp.productivityScore}%
                  </span>
                  <span
                    className={`${styles.scoreTrend} ${
                      emp.scoreTrendUp ? styles.trendUp : styles.trendDown
                    }`}
                  >
                    {emp.scoreTrendUp ? (
                      <FiArrowUp size={11} />
                    ) : (
                      <FiArrowDown size={11} />
                    )}
                    {emp.scoreTrend}%
                  </span>
                </div>
              </td>

              <td>{emp.activeTime}</td>
              <td>{emp.idleTime}</td>
              <td>{emp.focusTime}</td>

              <td>
                <div className={styles.attendanceCell}>
                  <span className={styles.attendanceCellValue}>
                    {emp.attendance}
                  </span>
                  <span
                    className={
                      emp.attendanceStatus === 'Present'
                        ? styles.statusPresent
                        : styles.statusLate
                    }
                  >
                    {emp.attendanceStatus}
                  </span>
                </div>
              </td>

              <td>
                <Sparkline data={emp.sparkline} color={emp.sparkColor} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);
